<template>
  <b-card
    :title= "title"
    tag="article"
    style="max-width: 20rem; background-color: black; color: white"
    class="mb-2"
  >
    <b-card-text>
      <a href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/Outriggers/servicesCard.vue" target="_blank" style="color:white">
        <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
      </a>
      <p style="font-size: 500%; color: orange">{{num}}</p>
    </b-card-text>
    <b-button @click.stop="clickHandler" variant="secondary">Show</b-button>
  </b-card>
</template>

<script>
export default{
  props: ['title', 'num', 'clickHandler']
}
</script>



// WEBPACK FOOTER //
// src/components/Outriggers/servicesCard.vue